/* Vienna Set animated street cover. Used by sections/vs-street.liquid */
(function () {
  if (!document.getElementById('vs-stage')) return;
  var stage = document.getElementById('vs-stage');
  var META = {"pink": [636, 1000], "white": [855, 1000], "carousel": [922, 900], "girl": [381, 760], "bridge": [1800, 653], "cafe": [725, 1000], "town": [586, 1000], "moto": [700, 368], "taxi": [800, 261], "conv": [800, 231], "red": [594, 1000]};
  var MID_W = 2660, FAR_W = 2400, GY = 752;

  /* ---------- street (mid layer): placement of your pieces ---------- */
  /* [id, x, bottom y, height, mirrored, lit?] */
  var ITEMS = [
    ['bridge',  410, 742, 1300 * META.bridge[1] / META.bridge[0], 0, 1, 0],
    ['white',    20, GY, 440, 0, 1, .7],
    ['pink',    380, GY, 450, 0, 1, .5],
    ['red',    1560, GY, 500, 0, 1, .5],
    ['car',    1845, 778, 440, 0, 1, .5],
    ['town',   2290, GY, 480, 0, 1, .22]
  ];
  /* parked vehicles: [id, x, baseline y, width] */
  var PARKED = [['moto', 1920, 820, 118], ['taxi', 2340, 832, 240]];
  var KEY = { pink: 'pink', white: 'white', car: 'carousel', bridge: 'bridge', town: 'town', red: 'red' };
  var B = [], L = [];
  B.push('<rect x="0" y="735" width="' + MID_W + '" height="165" fill="url(#vs-cob)"/>'); /* placeholder, replaced below so the street sits in front of the bridge */
  var back = [], front = [];
  ITEMS.forEach(function (it) {
    var m = META[KEY[it[0]]], h = it[3], w = h * m[0] / m[1], s = h / m[1], y = it[2] - h;
    var tf = it[4] ? 'translate(' + (it[1] + w) + ' ' + y + ') scale(' + (-s) + ' ' + s + ')' : 'translate(' + it[1] + ' ' + y + ') scale(' + s + ')';
    (it[0] === 'bridge' ? back : front).push('<use href="#vs-i_' + it[0] + '" transform="' + tf + '"/>');
    if (it[5]) L.push('<use href="#vs-l_' + it[0] + '" transform="' + tf + '"/>');
  });
  PARKED.forEach(function (v) {
    var m = META[v[0]], w = v[3], h = w * m[1] / m[0];
    front.push('<use href="#vs-i_' + v[0] + '" transform="translate(' + v[1] + ' ' + (v[2] - h) + ') scale(' + (w / m[0]) + ')"/>');
    /* headlight glow at night: taxi faces left, motorcycle faces right */
    var left = v[0] === 'taxi', gx = v[1] + (left ? w * .02 : w * .98), gy = v[2] - h * .42;
    L.push('<ellipse cx="' + (left ? gx - 40 : gx + 28) + '" cy="' + gy.toFixed(0) + '" rx="' + (left ? 90 : 52) + '" ry="' + (left ? 30 : 22) + '" fill="url(#vs-pool)"/>');
  });
  B = [back.join(''), '<rect x="0" y="735" width="' + MID_W + '" height="165" fill="url(#vs-cob)"/>', front.join('')];
  /* soft light pools on the cobbles at the doors, only at night */
  ITEMS.forEach(function (it) {
    if (!it[6]) return;
    var m = META[KEY[it[0]]], w = it[3] * m[0] / m[1], rx = it[0] === 'car' ? 170 : 105;
    L.unshift('<ellipse cx="' + (it[1] + w * it[6]).toFixed(0) + '" cy="772" rx="' + rx + '" ry="' + (rx * .3) + '" fill="url(#vs-pool)"/>');
  });

  /* ---------- far skyline, soft and hazy (placeholder) ---------- */
  var F = [], seed = 7;
  function rnd() { seed = (seed * 16807) % 2147483647; return seed / 2147483647; }
  var hz = ['#e4c6d0', '#dcbccb', '#e9d0d6', '#d6b8c8'];
  for (var fx = -10; fx < FAR_W + 20;) {
    var fw = 70 + rnd() * 100, fh = 170 + rnd() * 230, c = hz[Math.floor(rnd() * 4)];
    F.push('<rect x="' + fx + '" y="' + (780 - fh) + '" width="' + fw + '" height="' + fh + '" fill="' + c + '"/>');
    if (rnd() > .55) F.push('<polygon points="' + fx + ',' + (780 - fh) + ' ' + (fx + fw / 2) + ',' + (780 - fh - 50 - rnd() * 50) + ' ' + (fx + fw) + ',' + (780 - fh) + '" fill="#d3b2c3"/>');
    fx += fw + rnd() * 14;
  }
  function svg(w, inner, y0, hh) { y0 = y0 || 0; hh = hh || 900; return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 ' + y0 + ' ' + w + ' ' + hh + '" width="100%" height="100%" preserveAspectRatio="none">' + inner.join('') + '</svg>'; }
  /* the faint far skyline only occupies the middle of the sky, so only that strip is kept (smaller picture to move around) */
  var FAR_Y0 = 260, FAR_H = 520;
  document.getElementById('vs-far').innerHTML = svg(FAR_W, F, FAR_Y0, FAR_H);
  document.getElementById('vs-mid').innerHTML = svg(MID_W, B);
  document.getElementById('vs-midlit').innerHTML = svg(MID_W, L);

  /* ---------- painted sky ---------- */
  var STARS = [[73, 60, 70, 0], [180, 118, 34, 1], [297, 146, 26, 0], [419, 60, 34, 1], [642, 75, 76, 0], [1034, 53, 56, 1], [743, 185, 44, 0], [510, 228, 46, 1], [1140, 195, 46, 0], [1416, 66, 26, 0], [1554, 119, 34, 1], [99, 345, 84, 1], [24, 401, 26, 0], [551, 363, 26, 0], [848, 330, 44, 1], [1405, 252, 26, 0], [1346, 320, 26, 1], [502, 422, 26, 1], [1117, 438, 64, 0], [312, 477, 60, 1], [818, 552, 50, 0], [1360, 516, 34, 0], [1450, 563, 62, 0], [1594, 488, 56, 1], [60, 618, 48, 1], [160, 598, 26, 0], [314, 648, 30, 0], [581, 590, 46, 1], [705, 660, 26, 0], [1180, 592, 44, 1], [541, 742, 70, 0], [1244, 765, 56, 1], [658, 806, 34, 1], [995, 755, 22, 1], [890, 845, 36, 1]];
  var SKY_W = 1672, SKY_H = 941;
  var L_paint = document.getElementById('vs-paint');
  function buildSky() {
    var tw = Math.max(vh * SKY_W / SKY_H, vw * 0.9), html = '';
    var kinds = [['--sky-a', ''], ['--sky-m', ' vs-flip'], ['--sky-m', '']];
    kinds.forEach(function (k, i) {
      var sp = '';
      if (i < 2) STARS.forEach(function (st) {
        var size = st[2] * (vh / SKY_H) * 1.05;
        sp += '<i class="vs-sp ' + (st[3] ? 'g' : 'w') + '" style="left:' + (st[0] / SKY_W * 100).toFixed(2) + '%;top:' + (st[1] / SKY_H * 100).toFixed(2) + '%;width:' + size.toFixed(0) + 'px;height:' + size.toFixed(0) + 'px;animation-delay:-' + ((st[0] * 7 + st[1] * 3 + i * 400) % 3000 / 1000).toFixed(2) + 's;animation-duration:' + (2.4 + (st[0] % 5) * .5).toFixed(1) + 's"></i>';
      });
      if (i === 0) sp += '<i class="vs-moonglow" style="left:' + (1252 / SKY_W * 100).toFixed(2) + '%;top:' + (190 / SKY_H * 100).toFixed(2) + '%;width:' + (320 * vh / SKY_H).toFixed(0) + 'px;height:' + (320 * vh / SKY_H).toFixed(0) + 'px"></i>';
      html += '<div class="vs-tile' + k[1] + '" style="width:' + tw.toFixed(0) + 'px;background-image:var(' + k[0] + ')">' + sp + '</div>';
    });
    L_paint.innerHTML = html; L_paint._w = tw * 3; L_paint._tw = tw; tiles = L_paint.children; tileKey = '';
  }

  /* ---------- motion engine ---------- */
  var tiles = [], tileKey = '', dpr = window.devicePixelRatio || 1;
  function rp(v) { return Math.round(v * dpr) / dpr; }   /* snap movement to whole screen pixels */
  var p = 0, target = 0, vw = 0, vh = 0, sc = 1, lastInput = 0, dir = 1, reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var L_far = document.getElementById('vs-far'), L_mid = document.getElementById('vs-mid'), L_midlit = document.getElementById('vs-midlit');
  var cvEl = document.getElementById('vs-cv'), cvGlow = document.getElementById('vs-cvglow'), cvGlowI = cvGlow.firstElementChild;
  var girl = document.createElement('div'); girl.id = 'vs-girl'; girl.innerHTML = '<img alt="" src="' + stage.dataset.girl + '">'; document.getElementById('vs-mid').appendChild(girl);
  var GH = 130, GW = 130 * 381 / 760, GY0 = 792, GX0 = 60, GX1 = 560, CVW = 300, CVH = CVW * 231 / 800;

  /* ---------- the carousel spins: its ring of horses is wrapped round a cylinder and turned ---------- */
  var BAND = [138, 796, 448, 773], NC = 320, bandDirty = true, lastBand = 0;
  var bandImg = new Image(), bandLitImg = new Image(), bandReady = 0;
  bandImg.onload = bandLitImg.onload = function () { bandReady++; };
  bandImg.src = stage.dataset.band; bandLitImg.src = stage.dataset.bandLit;
  var cvB = document.createElement('canvas'), cvL = document.createElement('canvas');
  [cvB, cvL].forEach(function (c) { c.width = NC; c.height = BAND[3] - BAND[2]; });
  var carIt = ITEMS.filter(function (i) { return i[0] === 'car'; })[0];
  var spin = 0;
  function placeBand() {
    var s = carIt[3] / META.carousel[1];
    NC = Math.max(140, Math.min(460, Math.ceil((BAND[1] - BAND[0]) * s * sc * Math.min(dpr, 1.25))));
    bandDirty = true;
    [[cvB, 'vs-mid'], [cvL, 'vs-midlit']].forEach(function (c) {
      if (c[0].width !== NC) c[0].width = NC;
      var st = c[0].style;
      st.left = ((carIt[1] + BAND[0] * s) * sc) + 'px'; st.top = ((carIt[2] - carIt[3] + BAND[2] * s) * sc) + 'px';
      st.width = ((BAND[1] - BAND[0]) * s * sc) + 'px'; st.height = ((BAND[3] - BAND[2]) * s * sc) + 'px';
      document.getElementById(c[1]).appendChild(c[0]);
    });
  }
  function drawBand(ang) {
    if (bandReady < 2) return;
    var W = BAND[1] - BAND[0], Rw = W / 2, H = BAND[3] - BAND[2], sw = Math.max(1.4, W / NC * 1.15);
    [[cvB, bandImg], [cvL, bandLitImg]].forEach(function (c) {
      if (c[0] === cvL && !litOn) return;   /* the lit version is invisible in daylight, so skip drawing it */
      var g = c[0].getContext('2d'); g.clearRect(0, 0, NC, H);
      for (var i = 0; i < NC; i++) {
        var xo = (i + .5) / NC * 2 - 1, sx = Rw * (1 + Math.sin(Math.asin(xo) + ang)) - sw / 2;
        sx = Math.max(0, Math.min(W - sw, sx));
        g.drawImage(c[1], sx, 0, sw, H, i, 0, 1, H);
      }
    });
  }

  var D = [[242, 184, 162], [248, 217, 184], [253, 236, 204]], N = [[40, 46, 96], [82, 66, 126], [142, 100, 138]];
  function mix(a, b, t) { return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }); }
  function rgb(a) { return 'rgb(' + a.join(',') + ')'; }
  function sm(a, b, x) { x = Math.min(1, Math.max(0, (x - a) / (b - a))); return x * x * (3 - 2 * x); }
  var sunEl = document.getElementById('vs-sun'), darkEl = document.getElementById('vs-dark'), duskEl = document.getElementById('vs-dusk'), shootEl = document.getElementById('vs-shoot');
  var litOn = false, lastKey = '', lastW = -1, lastH = -1, rsTimer = 0;

  function resize() {
    var off = Math.max(0, Math.round(stage.getBoundingClientRect().top + window.pageYOffset)) + 'px';
    if (stage.style.getPropertyValue('--vs-offset') !== off) stage.style.setProperty('--vs-offset', off);
    var w = stage.clientWidth, h = stage.clientHeight;
    if (w === lastW && h === lastH) return;   /* nothing changed (e.g. phone address bar sliding): leave the scene alone so it does not flicker */
    lastW = w; lastH = h; vw = w; vh = h;
    sc = Math.max(vh / 900, vw * 1.5 / MID_W);
    [[L_far, FAR_W], [L_mid, MID_W], [L_midlit, MID_W]].forEach(function (l) { l[0].style.width = (l[1] * sc) + 'px'; l[0].style.height = (900 * sc) + 'px'; l[0]._w = l[1] * sc; });
    L_far.style.height = (FAR_H * sc) + 'px'; L_far.style.bottom = ((900 - 780) * sc) + 'px';   /* cropped strip, sits exactly where it used to */
    buildSky(); placeBand();
    girl.style.width = (GW * sc) + 'px'; girl.style.height = (GH * sc) + 'px'; girl.style.top = ((GY0 - GH) * sc) + 'px';
    cvEl.style.width = (CVW * sc) + 'px'; cvEl.style.bottom = ((900 - 872) * sc) + 'px'; cvGlow.style.bottom = cvEl.style.bottom; cvGlow.style.width = (CVW * sc) + 'px';
    cvGlowI.style.left = ((CVW * .045 - 150) * sc) + 'px'; cvGlowI.style.bottom = ((CVH * .36 - 55) * sc) + 'px'; cvGlowI.style.width = (300 * sc) + 'px'; cvGlowI.style.height = (110 * sc) + 'px';
    lastKey = ''; draw();
  }
  function onResize() { clearTimeout(rsTimer); rsTimer = setTimeout(resize, 120); }
  function draw() {
    /* time of day follows where the camera is in the street: light at the white house, pink house and bridge, dusk by the red house, evening at the carousel */
    var camX = (p * Math.max(0, L_mid._w - vw) + vw / 2) / sc, tt = Math.min(1, Math.max(0, (camX - 950) / 1150));
    var n = sm(.12, .9, tt) * .85, dn = sm(.18, .9, tt);
    var key = Math.round(n * 400) + '/' + Math.round(dn * 400);
    if (key !== lastKey) {   /* only touch the page when the light has visibly changed */
      lastKey = key;
      var vis = function (el, o) { el.style.opacity = o.toFixed(3); el.style.visibility = o < .004 ? 'hidden' : 'visible'; };   /* fully invisible layers are switched off, so the browser does not blend them */
      vis(darkEl, n * .31);
      vis(L_midlit, n);
      vis(cvGlow, n);
      vis(duskEl, (1 - dn) * .66);
      vis(shootEl, dn);
      vis(sunEl, Math.max(0, 1 - dn * 1.8));
      if (n >= .004 && !litOn) bandDirty = true;
      litOn = n >= .004;
      var c1 = rgb(mix(D[0], N[0], n)), c2 = rgb(mix(D[1], N[1], n)), c3 = rgb(mix(D[2], N[2], n));
      stage.style.background = 'linear-gradient(180deg,' + c1 + ' 0%,' + c2 + ' 55%,' + c3 + ' 100%)';
      duskEl.style.background = 'linear-gradient(180deg,' + c1 + ' 0%,' + c2 + ' 58%,' + c3 + ' 100%)';
    }
    sunEl.style.transform = 'translate3d(0,' + rp(tt * .34 * vh) + 'px,0)';
    var px = rp(p * Math.min(Math.max(0, L_paint._w - vw), .28 * Math.max(1, L_mid._w - vw)));
    L_paint.style.transform = 'translate3d(' + (-px) + 'px,0,0)';
    [L_far, L_mid, L_midlit].forEach(function (l) { l.style.transform = 'translate3d(' + (-rp(p * Math.max(0, l._w - vw))) + 'px,0,0)'; });
    /* twinkling stars in sky tiles that are off-screen are paused and hidden */
    if (tiles.length) {
      var tw = L_paint._tw, k = '';
      for (var i = 0; i < tiles.length; i++) { var x0 = i * (tw - 2), on = x0 < px + vw + 120 && x0 + tw > px - 120; k += on ? '1' : '0'; }
      if (k !== tileKey) { tileKey = k; for (var j = 0; j < tiles.length; j++) tiles[j].classList.toggle('vs-off', k.charAt(j) === '0'); }
    }
  }
  var span = function () { return Math.max(1, L_mid._w - vw); };
  function nudge(dx) { target = Math.min(1, Math.max(0, target + dx / span())); lastInput = performance.now(); }

  stage.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY) * 1.2) { e.preventDefault(); nudge(e.deltaX * .9); } }, { passive: false });  /* sideways trackpad swipes move the street; up/down scrolls the page */
  var dragging = false, lx = 0;
  stage.addEventListener('pointerdown', function (e) { dragging = true; lx = e.clientX; stage.classList.add('vs-drag'); try { stage.setPointerCapture(e.pointerId); } catch (x) {} lastInput = performance.now(); });
  stage.addEventListener('pointermove', function (e) { if (!dragging) return; nudge(-(e.clientX - lx)); lx = e.clientX; });
  ['pointerup', 'pointercancel'].forEach(function (t) { stage.addEventListener(t, function () { dragging = false; stage.classList.remove('vs-drag'); }); });
  window.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') nudge(160); if (e.key === 'ArrowLeft') nudge(-160); });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', resize);

  var last = performance.now(), clock = 5;   /* the cameo and the car run on their own clock */
  var onScreen = true;
  if (window.IntersectionObserver) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(stage);
  function tick(t) {
    var dt = Math.min(.05, (t - last) / 1000); last = t;
    if (!onScreen) { requestAnimationFrame(tick); return; }
    if (!reduce && t - lastInput > 4500) { target += dir * dt * .012; if (target >= 1) { target = 1; dir = -1; } if (target <= 0) { target = 0; dir = 1; } }
    p += (target - p) * Math.min(1, dt * 6);
    draw();
    if (!reduce) { clock += dt; spin += dt * .5; }

    /* umbrella girl: a short cameo, one stretch of the street, then she's gone for a bit */
    var cyc = 17, ct = clock % cyc, walkT = 11.5;
    if (ct < walkT) {
      var u = ct / walkT, gx = GX0 + (GX1 - GX0) * u, ph = clock * 6.5;
      var op = Math.min(1, ct / .9, (walkT - ct) / .9);
      girl.style.opacity = op.toFixed(3);
      girl.style.transform = 'translate3d(' + (gx * sc).toFixed(1) + 'px,' + (-Math.abs(Math.sin(ph)) * 2.6 * sc).toFixed(2) + 'px,0) rotate(' + (Math.sin(ph) * 1.2).toFixed(2) + 'deg)';
    } else girl.style.opacity = 0;

    /* the white convertible drives across the whole cover, right to left */
    var spd = 118 * sc, W2 = CVW * sc, trip = (vw + W2 + 120) / spd, pause = 3.5, cc = (clock * 1.0 + 7) % (trip + pause);
    var cx2 = cc < trip ? vw + 60 - cc * spd : -W2 - 400;
    var bob = reduce ? 0 : Math.sin(clock * 11) * .55;
    var tf = 'translate3d(' + cx2.toFixed(1) + 'px,' + bob.toFixed(2) + 'px,0)';
    cvEl.style.transform = tf; cvGlow.style.transform = tf;

    var cx = carIt[1] * sc - p * Math.max(0, L_mid._w - vw);
    if (reduce) { if (bandDirty && bandReady >= 2) { bandDirty = false; drawBand(0); } } else if (t - lastBand > 41 && cx < vw + 40 && cx + carIt[3] * META.carousel[0] / META.carousel[1] * sc > -40) { lastBand = t; drawBand(spin); }
    requestAnimationFrame(tick);
  }
  resize();
  p = target = 0; /* opens on the white house, then the pink house, then the bridge */
  var q = /[?&]p=([0-9.]+)/.exec(location.search); if (q) { p = target = Math.min(1, +q[1]); lastInput = performance.now() + 1e9; }
  requestAnimationFrame(tick);
})();
